import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const StructurePrevention = ({
  width = 17,
  height = 17,
  className,
  color,
  decorative = false,
  ariaLabel = "StructurePrevention",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 17 17"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        strokeWidth="0.3"
        d="M4.394 16.15a.3.3 0 0 1-.21-.086l-3.949-3.95a.296.296 0 1 1 .419-.418l3.95 3.95a.296.296 0 0 1-.21.505Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0.3"
        d="M3.482 15.241a.3.3 0 0 1-.21-.086l-2.13-2.132a.296.296 0 0 1 0-.418L3.805 9.94a.296.296 0 0 1 .418 0l2.132 2.132a.296.296 0 0 1 0 .418L3.69 15.155a.3.3 0 0 1-.209.086Zm-1.713-2.427 1.713 1.713 2.246-2.246-1.713-1.713z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0.3"
        d="M7.942 14.365a.3.3 0 0 1-.21-.086l-5.708-5.71a.296.296 0 1 1 .419-.418l5.709 5.709a.296.296 0 0 1-.21.505Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0.3"
        d="M6.627 13.052a.3.3 0 0 1-.21-.087l-3.08-3.08a.296.296 0 0 1 0-.419l7.045-7.045a.296.296 0 0 1 .418 0l3.081 3.08a.296.296 0 0 1 0 .419l-7.045 7.045a.3.3 0 0 1-.21.087ZM3.965 9.675l2.662 2.662 6.626-6.626-2.662-2.662z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0.3"
        d="M12.962 5.298a.3.3 0 0 1-.21-.087l-1.665-1.665a.296.296 0 0 1 0-.419l.69-.69c.239-.239.558-.37.898-.37s.66.131.9.37l.286.287c.239.24.37.558.37.899s-.131.66-.37.899l-.69.69a.3.3 0 0 1-.21.086Zm-1.247-1.961 1.246 1.247.48-.48a.67.67 0 0 0 .199-.481.67.67 0 0 0-.198-.48l-.286-.287a.67.67 0 0 0-.48-.197.67.67 0 0 0-.481.197z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0.3"
        d="M13.507 3.087a.295.295 0 0 1-.21-.506L15.643.237a.296.296 0 1 1 .419.419L13.716 3a.3.3 0 0 1-.21.087ZM10.035 5.132a.3.3 0 0 1-.21-.087l-.824-.825a.296.296 0 1 1 .418-.418l.825.824a.296.296 0 0 1-.209.506ZM8.605 6.56a.3.3 0 0 1-.209-.087l-.825-.825a.296.296 0 1 1 .419-.419l.825.825a.296.296 0 0 1-.21.505ZM7.176 7.987a.3.3 0 0 1-.21-.086l-.825-.825a.296.296 0 1 1 .419-.419l.825.825a.296.296 0 0 1-.21.505ZM5.746 9.415a.3.3 0 0 1-.21-.087l-.824-.825a.296.296 0 1 1 .418-.418l.825.825a.296.296 0 0 1-.209.505Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
